function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["breakpoints", "centered", "children", "className", "ellipsis", "heading", "headingProps", "spanProps"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyMedium } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import { truncateText } from "../../../../styles/styled-components/text.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseTd } from "../base-table/base-td.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledTd = function UnstyledTd(props) {
  var breakpoints = props.breakpoints,
    centered = props.centered,
    children = props.children,
    className = props.className,
    ellipsis = props.ellipsis,
    heading = props.heading,
    headingProps = props.headingProps,
    spanProps = props.spanProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseTd, _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-table__standard-td': true,
      'bf-table__standard-td--breakpoints': !!breakpoints,
      'bf-table__standard-td--centered': centered,
      'bf-table__standard-td--ellipsis': ellipsis
    }, "".concat(className), !!className))
  }), !!heading && /*#__PURE__*/React.createElement("h6", _extends({}, headingProps, {
    className: classnames(_defineProperty({
      'bf-table__standard-td-heading': true
    }, "".concat(headingProps === null || headingProps === void 0 ? void 0 : headingProps.className), !!(headingProps !== null && headingProps !== void 0 && headingProps.className)))
  }), heading), /*#__PURE__*/React.createElement("span", _extends({}, spanProps, {
    className: classnames(_defineProperty({
      'bf-table__standard-td-content': true
    }, "".concat(spanProps === null || spanProps === void 0 ? void 0 : spanProps.className), !!(spanProps !== null && spanProps !== void 0 && spanProps.className)))
  }), children));
};
var blockTd = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  padding: 15px 15px 0;\n  text-align: left;\n\n  &:last-child {\n    padding: 15px;\n  }\n\n  .bf-table__standard-td-heading {\n    display: block;\n  }\n"])));
var getTableTd = function getTableTd(centered) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: table-cell;\n    padding: 15px;\n    text-align: ", ";\n\n    .bf-table__standard-td-heading {\n      display: none;\n    }\n  "])), centered ? 'center' : 'left');
};
var getTdBreakpoints = function getTdBreakpoints(breakpoints, centered) {
  return breakpoints.map(function (breakpoint, index) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "])), breakpoint, index % 2 === 0 ? getTableTd(centered) : blockTd);
  });
};
var StyledTd = styled(UnstyledTd)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  .bf-table__standard-td-heading {\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    margin: 0 0 5px;\n  }\n"])), blockTd, function (_ref) {
  var breakpoints = _ref.breakpoints,
    centered = _ref.centered;
  return getTdBreakpoints(breakpoints || [], centered);
}, function (_ref2) {
  var ellipsis = _ref2.ellipsis;
  return ellipsis ? truncateText() : '';
}, fontFamilyMedium);
/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/td
 * @param props TdProps
 * @returns FunctionComponent<TdProps>
 */
var Td = function Td(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledTd, _extends({}, props)));
};
export { Td };